import { FC, useEffect, useRef } from 'react'

import { Word } from 'models'
import { useAppContext } from 'context/app-context'
import { convertToImage } from '../utils'
import {
  CenterContent,
  Container,
  Description,
  Dl,
  Header,
  Title,
} from '../styled'
import { Logo } from './logo'

export const ShareTile: FC<{
  word: Word
  onClose: (o: Blob | null) => void
}> = ({ word, onClose }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const { colors } = useAppContext()

  const handleShare = async () => {
    if (containerRef.current) {
      const output = await convertToImage(
        containerRef.current,
        containerRef.current.getBoundingClientRect()
      )
      onClose(output)
    }
  }

  useEffect(() => {
    void handleShare()
  }, [])

  if (!word) {
    return null
  }

  return (
    <Container
      $variant="share"
      ref={containerRef}
      $color={
        colors && word.category in colors
          ? colors[word.category as keyof typeof colors]
          : ''
      }
    >
      <Header>
        <Logo />
        <span>#АЗАТЛЫК СҮЗЛЕГЕ</span>
      </Header>

      <CenterContent>
        <Title hyphens={!word.tatar.includes(' ')}>
          <span>{word.tatar}</span>
        </Title>

        <Description>{word.description}</Description>
      </CenterContent>

      <Dl>
        <dt>english: </dt>
        <dd>{word.english}</dd>
        <dt>Русский: </dt>
        <dd>{word.russian}</dd>
      </Dl>
    </Container>
  )
}
